import { useContext, useState } from "react";
import type { AnomalyProcess } from "@/models/file-submission.tsx";
import {
  useAnomalyProcesses,
  useActivateAnomalyProcess,
  useDeactivateAnomalyProcess,
} from "@/queries";
import { FileSubmissionsContext } from "@/components/layout/FileSubmissionsTracker";

export default function useAnomaliesAdmin() {
  const anomaliesQuery = useAnomalyProcesses();
  const activateMutation = useActivateAnomalyProcess();
  const deactivateMutation = useDeactivateAnomalyProcess();
  const { showToast } = useContext(FileSubmissionsContext);
  const [pendingToggle, setPendingToggle] = useState<AnomalyProcess | null>(
    null
  );

  const anomalyProcesses = anomaliesQuery.data ?? [];
  const error =
    anomaliesQuery.error ?? activateMutation.error ?? deactivateMutation.error;

  const handleToggleRequest = (anomalyProcess: AnomalyProcess) => {
    setPendingToggle(anomalyProcess);
  };

  const handleCancelToggle = () => {
    setPendingToggle(null);
  };

  const handleConfirmToggle = () => {
    if (!pendingToggle) return;
    const anomalyProcess = pendingToggle;
    setPendingToggle(null);
    const mutation = anomalyProcess.Active
      ? deactivateMutation
      : activateMutation;
    mutation.mutate(anomalyProcess.Id, {
      onSuccess: (saved) => {
        showToast(
          "success",
          "Anomaly Process Updated",
          `"${saved.Name}" is now ${saved.Active ? "active" : "inactive"}.`
        );
      },
    });
  };

  return {
    anomalyProcesses,
    isLoading: anomaliesQuery.isLoading,
    saving: activateMutation.isPending || deactivateMutation.isPending,
    error,
    pendingToggle,
    handleToggleRequest,
    handleCancelToggle,
    handleConfirmToggle,
  };
}
